import { useNavigate, useLocation } from 'react-router-dom';

export default function BackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <button
      className="back-button"
      onClick={() => navigate('/', { state: { from: location } })}
    >
      ← Zpět
    </button>
  );
}